/*
 * File: GetStudentIssuedForms.ts
 * Author: Austin Robinson
 * Date Created: 9/14/2023
 * Copyright (c) DrivingDoc 2023
 */
import { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

export type GetStudentIssuedFormsParams = {
  id: string;
  page: number;
  pageSize: number;
};

export type StudentIssuedForm = {
  tenant_id: string;
  id: string;
  student_user_id: string;
  form: {
    id: string;
    name: string;
  };
  expires: string;
  issued_by_user: {
    tenant_id: string;
    id: string;
    title: string | null;
    first_name: string | null;
    middle_name: string | null;
    last_name: string | null;
    nickname: string | null;
    email: string | null;
    date_of_birth: string | null;
    sex: string | null;
    active: boolean;
    created_at: string | null;
    updated_at: string | null;
    created_by: string | null;
    updated_by: string | null;
    des_id: string | null;
  } | null;
  issued_at: string;
};

export type GetStudentIssuedFormsResult = {
  rows: StudentIssuedForm[];
  count: number;
} | null;

async function getStudentIssuedForms(params: GetStudentIssuedFormsParams) {
  const { id, ...queryParams } = params;

  // make api call
  const result = await privateApi.get<GetStudentIssuedFormsResult>(
    `${import.meta.env.VITE_API_BASE_URL}/users/students/${id}/issuedForms`,
    {
      params: queryParams,
    },
  );

  return result.data;
}

const useGetStudentIssuedForms = createQuery<
  GetStudentIssuedFormsResult,
  GetStudentIssuedFormsParams,
  AxiosError<ErrorResponse>
>({
  queryKey: ['student_issued_forms'],
  fetcher: (variables) => getStudentIssuedForms(variables),
});

export { useGetStudentIssuedForms };
